import { Box, Stack, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import { ProductInfo } from '../../context/product_context'
import { maskCurrency } from '../../utils/maks'
import { useCoin } from '../../context/coin_context'
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'
import { ProductTicketType, useConfigs } from '../../context/configs_context'
import { BarcodeRect } from '../ProductBarcodePrintPosition'

interface ProductBarcodeProps {
    product: ProductInfo
}

export function ProductBarcode({ product }: ProductBarcodeProps) {
    const { configs } = useConfigs()
    const barcodeRef = useRef<HTMLCanvasElement | null>(null)

    useEffect(() => {
        if (!configs.productBarcodePrintPosition) return

        /* if (configs.productTicketType === ProductTicketType.Barcode)
            JsBarcode(barcodeRef.current, product.barcodes?.[0], {
                width: 2,
                height: 40,
                fontSize: 14,
            }) */

        const data = JSON.parse(configs.productBarcodePrintPosition)
        const codeType = data.codeType ?? 'barcode'
        const fontFamily = data.fontFamily || 'sans-serif'

        setTimeout(() => {
            const dataPrint = document.getElementById(
                `data-print-barcode-${product.id}`
            )
            if (!dataPrint) return

            dataPrint.style.background = data.bgColor

            for (let i = 0; i < data.printHorizontalQnt; i++) {
                const containerHeight = 100 / data.printHorizontalQnt

                const containerEl = document.createElement('div')
                containerEl.style.height = `${containerHeight}vh`
                containerEl.style.position = 'relative'

                if (data.barcodeFormat === 'EAN') {
                    data.barcodeFormat = `EAN${product.barcodes?.[0]?.length}`
                }

                data.boxes.forEach((box: BarcodeRect) => {
                    if (!box.isActive) return

                    const el = document.createElement('div')
                    el.style.position = 'absolute'
                    el.style.left = `${box.yProp}%`
                    el.style.bottom = `${box.xProp}%`
                    el.style.fontSize = `${box.fontSize}px`
                    el.style.fontFamily = fontFamily
                    el.style.fontWeight = box.isBold ? 'bold' : '400'
                    el.style.transform = 'rotate(-0.25turn) translate(0, 100%)'
                    el.style.transformOrigin = '0 100%'
                    el.style.width = `${
                        containerHeight - (containerHeight * box.xProp) / 100
                    }vh`

                    if (box.isVerticalText) {
                        el.style.writingMode = 'vertical-rl'
                        el.style.textOrientation = 'mixed'
                    }

                    if (box.text === 'Empresa') {
                        el.innerHTML = configs.companyName ?? ''
                    }

                    if (box.text === 'Nome produto') {
                        el.innerHTML = product.name ?? ''
                    }

                    if (box.text === 'código interno produto') {
                        el.innerHTML = `Ref: ${product.internalCodes[0]}`
                    }

                    if (box.text === 'loc produto') {
                        el.innerHTML = `Loc: ${
                            product.localizations[0]?.value ?? '---'
                        }`
                    }

                    if (box.text === 'código barr produto') {
                        if (codeType === 'barcode') {
                            const codeId = `barcode-${product.id}-${i}`
                            el.innerHTML = `<canvas id="${codeId}"></canvas>`

                            setTimeout(() => {
                                JsBarcode(`#${codeId}`, product.barcodes?.[0], {
                                    width: data.width,
                                    height: data.height,
                                    fontSize: box.fontSize,
                                    format: data.barcodeFormat,
                                    margin: 0,
                                    ean128: data.ean128,
                                })
                            }, 50)
                        } else if (codeType === 'qr') {
                            const codeId = `qr-${product.id}-${i}`
                            el.innerHTML = `<canvas id="${codeId}"></canvas>`

                            setTimeout(() => {
                                const canvas = document.getElementById(codeId)
                                if (canvas instanceof HTMLCanvasElement)
                                    QRCode.toCanvas(
                                        canvas,
                                        product.barcodes?.[0] ?? '',
                                        {
                                            width: Math.max(
                                                Number(data.height) || 80,
                                                80
                                            ),
                                            margin: 0,
                                        }
                                    )
                            }, 50)
                        } else {
                            el.innerHTML = product.barcodes?.[0] ?? ''
                        }
                    }

                    if (box.text === 'preço produto') {
                        el.innerHTML = `${product.coin?.symbol} ${maskCurrency(
                            product.salePrice,
                            product.coin
                        )}`
                    }

                    if (box.text === 'observacion') {
                        el.innerHTML = product.aplication ?? ''
                    }

                    if (box.text === 'observacion 2') {
                        el.innerHTML = product.observation ?? ''
                    }

                    containerEl.appendChild(el)
                    /* containerEl.innerHTML = 'adsaasasasdas' */
                })

                dataPrint.appendChild(containerEl)
            }
        }, 100)
    }, [])

    return (
        <Stack
            direction="column-reverse"
            width="100%"
            height={'100vh'}
            id={`data-print-barcode-${product.id}`}
            position={'relative'}
        ></Stack>
    )
}

interface Props {
    products: ProductInfo[]
    handleClose(): void
}

export function ProductBarcodeNoteDialog({ handleClose, products }: Props) {
    useEffect(() => {
        setTimeout(() => {
            window.scroll(0, 0)
            window.print()
            handleClose()
        }, 200)
    }, [])

    return (
        <Box className="printable">
            <Stack direction={'column'}>
                {products.map((product) => (
                    <ProductBarcode product={product} />
                ))}
            </Stack>
        </Box>
    )
}
